<template>
    <v-dialog v-model="show" width="500">
        <pad-login @login="show = false" />
    </v-dialog>
</template>

<script>
import PadLogin from '@/components/PadLogin'

export default {
    name: 'pad-login-popup',
    components: { PadLogin },
    computed: {
        show: {
            get() {
                return this.$store.getters['auth/show']
            },
            set(v) {
                this.$store.commit('auth/show', { show: v })
            }
        }
    }
}
</script>
